import React, { useState } from 'react'
import {Button, Dimmer, Grid, Header, Icon, Loader, Message, Segment} from "semantic-ui-react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
var toBlob = require('canvas-toBlob');

const defaultSrc =
    "https://raw.githubusercontent.com/roadmanfong/react-cropper/master/example/img/child.jpg";


const Photo = (props) => {
    const [image, setImage] = useState();
    const [cropData, setCropData] = useState("#");
    const [cropper, setCropper] = useState();
    const [loading, setLoading] = useState(false);
    const [errorString, setError] = useState();

    const onChange = (e) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result);
        };

        if (typeof files[0] !== "undefined") {
            reader.readAsDataURL(files[0]);
        }
    };

    const submitForm = (e) => {
        if (typeof cropper !== "undefined") {
            setCropData(cropper.getCroppedCanvas().toDataURL());
            let mimeType = image.substring(image.indexOf(":")+1, image.indexOf(";"));
            console.log(mimeType);

            cropper.getCroppedCanvas({maxHeight: 1000}).toBlob((blob) => {
                props.setCroppedPhoto(blob);


                if (props.requirePassword === true) {
                    props.setStep("password");
                }
                else {
                    setLoading(true);
                    props.dataManager.submit(props.jwt, blob, null)
                        .then(response => {
                            setLoading(false);
                            if (typeof response.data.success !== "undefined") {
                                if (response.data.success == 0) {
                                    setError(response.data.errorMessage);
                                } else {
                                    props.setStep("complete");
                                }
                            }
                            else
                            {
                                setError(response.data);
                                setLoading(false);
                            }
                        });
                }

            }, mimeType);
        }

    }

    return (
        <div>
            <Dimmer active={loading} inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>

            <Header as='h2'>Photo Selection</Header>

            { (typeof errorString !== "undefined") &&
                <Message error icon>
                    <Icon name='exclamation' />
                    <Message.Content>
                        <Message.Header>An error occurred</Message.Header>
                        {errorString}
                    </Message.Content>
                </Message>
            }

            <Grid stackable columns={2}>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <p>You must provide a current digital photo of yourself. This photo will be stored securely on our servers and only used by IATF Global Oversight and approved Proctored Facility personnel as needed to verify your identity.</p>

                        <p>Please note the following important technical requirements:</p>
                        <ul>
                            <li>Image must be in <strong>JPEG</strong> or <strong>PNG</strong> format.  No other image formats will be accepted.</li>
                            <li>Image must be in a <strong>4x6 ratio</strong>, and must be in <strong>portrait orientation</strong>.  This is similar to the photo on passports and many forms of Government ID.  You will be able to crop the photo after uploading it.</li>
                            <li>The image must meet minimum size requirements.  If you upload an image that is too small, this will be indicated.</li>
                        </ul>
                        <br />
                        <input className='ui button' type="file" accept="image/jpeg,image/png" onChange={onChange} />
                        <br />
                        <br />

                    </Grid.Column>
                    <Grid.Column width={8}>
                        { (typeof image == "undefined" ) &&
                            <Segment placeholder style={{ height: 400, width: "100%" }}>
                                <Header icon>
                                    <Icon name='photo' />
                                    Upload a photo using the "Choose File" option.
                                </Header>
                            </Segment>
                        }
                        { (typeof image !== "undefined" ) &&
                        <div><Cropper
                            style={{ height: 400, width: "100%" }}
                            aspectRatio={4/6}
                            initialAspectRatio={4/6}
                            preview=".img-preview"
                            src={image}
                            viewMode={1}
                            minCropBoxHeight={300}
                            minCropBoxWidth={200}
                            background={false}
                            responsive={true}
                            autoCropArea={1}
                            zoomable={false}
                            zoomOnWheel={false}
                            zoomOnTouch={false}
                            checkOrientation={false}
                            onInitialized={(instance) => {
                                setCropper(instance);
                            }}
                            guides={true}
                        />
                            <Message size='tiny' warning attached='bottom'>
                                <Icon name='warning' />
                                Drag the rectangle to ensure your photo is centered in the highlighted shape.
                            </Message>
                        </div>
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            <Button disabled={typeof image === "undefined"} style={{marginTop: '2em'}} type='submit' onClick={submitForm}>Next Step</Button>
        </div>
    )
}

export default Photo;